var _circle, _path, _path2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReadLaterThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#3a3a3a",
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.9581 8.69568h-4.6956c-.86446 0-1.56523.70077-1.56523 1.56522v12.5217c0 .8645.70077 1.5653 1.56523 1.5653h11.4782c.8645 0 1.5653-.7008 1.5653-1.5653v-4.6956",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.56522
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.0449 7.65218c0-.5763.4672-1.04348 1.0435-1.04348h6.2609c.5763 0 1.0434.46718 1.0434 1.04348v7.84692c0 .6363-.7264.9996-1.2354.6178l-2.3124-1.7343c-.371-.2782-.8811-.2782-1.2522 0l-2.3123 1.7343c-.509.3818-1.2355.0185-1.2355-.6178z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.56522
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.8262 11.8261h2.6087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.8262 14.9565h1.0435"
  }))));
}

export default SvgReadLaterThumb;